import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type {
  CreateHawbPayload,
  HawbDeleteImpact,
  HawbDetail,
  HawbFormPayload,
  HawbOption,
  HawbRow,
  HawbUpdatePreview,
  ImportCommitResult,
  ImportPreview,
  ItemLinkWarning,
  LinkTagResult,
  MawbSuggestion,
} from "#/types/manifest";

export const manifestApi = {
  getAll: (params?: BaseFilterParams): Promise<ApiResponse<Paginated<HawbRow[]>>> =>
    api.get("/manifest/hawb", { params }),
  getById: (id: number): Promise<ApiResponse<HawbDetail>> => api.get(`/manifest/hawb/${id}`),
  getOptions: (params: {
    search?: string;
    has_untagged?: boolean;
  }): Promise<ApiResponse<HawbOption[]>> => api.get("/manifest/hawb/options", { params }),
  suggestMawb: (search: string): Promise<ApiResponse<MawbSuggestion[]>> =>
    api.get("/manifest/mawb/suggest", { params: { search } }),
  create: (body: CreateHawbPayload): Promise<ApiResponse<HawbRow>> =>
    api.post("/manifest/hawb", body),
  updatePreview: (id: number, body: HawbFormPayload): Promise<ApiResponse<HawbUpdatePreview>> =>
    api.post(`/manifest/hawb/${id}/update-preview`, body),
  update: (id: number, body: HawbFormPayload): Promise<ApiResponse<HawbRow>> =>
    api.patch(`/manifest/hawb/${id}`, body),
  getDeleteImpact: (id: number): Promise<ApiResponse<HawbDeleteImpact>> =>
    api.get(`/manifest/hawb/${id}/delete-impact`),
  delete: (id: number): Promise<ApiResponse<{ deleted_items: number }>> =>
    api.delete(`/manifest/hawb/${id}`),
  importPreview: (file: File, onProgress?: (progress: number) => void) =>
    api.uploadFile<ApiResponse<ImportPreview>>("/manifest/import/preview", file, "file", onProgress),
  importCommit: (file: File, overrideHawbIds: number[]): Promise<ApiResponse<ImportCommitResult>> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("override_hawb_ids", JSON.stringify(overrideHawbIds));
    return api.post("/manifest/import/commit", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  linkTags: (hawbId: number, rfidIds: number[]): Promise<ApiResponse<{ results: LinkTagResult[] }>> =>
    api.post(`/manifest/hawb/${hawbId}/link-tags`, { rfid_ids: rfidIds }),
  itemLinkPreview: (
    itemIds: number[],
    hawbId: number | null,
  ): Promise<ApiResponse<{ warnings: ItemLinkWarning[] }>> =>
    api.post("/manifest/item-link/preview", { item_ids: itemIds, hawb_id: hawbId }),
  itemLink: (itemIds: number[], hawbId: number | null): Promise<ApiResponse<{ updated: number }>> =>
    api.post("/manifest/item-link", { item_ids: itemIds, hawb_id: hawbId }),
};
